export function ContactInfo() {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-4xl font-bold font-roboto leading-snug text-[#00d9d9]">
        Μην διστάζεις να επικοινωνήσεις μαζί μας, για οποιαδήποτε απορία, είμαστε εδώ να σε βοηθήσουμε.
      </h2>
      <p className="text-white/70 text-base">
        Στείλε email στο{' '}
        <a href="mailto:info@paduapp.gr" className="font-semibold text-white hover:text-[#00d9d9] transition-colors">
          info@paduapp.gr
        </a>{' '}
        και θα απαντήσουμε το συντομότερο δυνατό.
      </p>
    </div>
  );
}
